import { SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataCreate {
  public async build(element: any): Promise<FormData> {
    let { image, type, name, email, dueDate, contractTemplate, parentSystem } = element;
    let formData = new FormData();

    if (typeof image === 'string' && image?.toLowerCase().includes(';base64')) {
      formData.append(
        'image',
        new File(
          [await GlobalUtils.blobImageFromBase64String(image)],
          image?.toLowerCase().includes('png') ? 'filename.png' : 'filename.jpeg'
        )
      );
    }

    if (contractTemplate instanceof File) {
      formData.append('contractTemplate', contractTemplate, contractTemplate.name);
    } else if (typeof contractTemplate === 'string' && contractTemplate?.toLowerCase().includes(';base64')) {
      const parts = contractTemplate.split(';');
      const mimeType = parts[0].split(':')[1];
      const base64 = parts[1].split(',')[1];

      let extension = 'bin';
      if (mimeType) {
        extension = mimeType.split('/')[1] || 'bin';
      }

      const blob = await GlobalUtils.blobFromBase64String(base64, mimeType);
      formData.append('contractTemplate', new File([blob], `template.${extension}`, { type: mimeType }));
    }

    if (dueDate !== undefined && dueDate !== null) {
      const dueDateValue = Number(dueDate);
      if (!isNaN(dueDateValue)) {
        formData.append('dueDate', dueDateValue.toString());
      } else {
        console.error('❌ Valor inválido para dueDate:', dueDate);
      }
    } else {
      console.warn('⚠️ dueDate não fornecido no formulário');
    }
    formData.append('name', name?.toUpperCase() || '');
    formData.append('email', email || '');

    if (typeof type === 'string' && type in SystemTypeIdEnum) {
      const typeId = SystemTypeIdEnum[type as keyof typeof SystemTypeIdEnum];
      if (!isNaN(Number(typeId))) {
        formData.append('type', typeId.toString());
      } else {
        console.error(`❌ Tipo inválido (não numérico): ${type} -> ${typeId}`);
      }
    } else if (typeof type === 'number' && !isNaN(type)) {
      formData.append('type', type.toString());
    } else {
      console.error(`❌ Tipo inválido: ${type}, usando o tipo 1 como fallback`);
      formData.append('type', '1');
    }

    if (parentSystem) {
      formData.append('parentSystemId', parentSystem);
    }
    return formData;
  }
}